"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlTexture2d = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IGlTexture2d}
 */
class GlTexture2d {
    constructor(name, data) {
        this.name = name;
        this.data = data;
        this.uniformLocation = null;
        this.texture = null;
        this.isDirty = true;
        this.textureUnit = null;
    }
    initialize(componentRenderer) {
        componentRenderer.addTexture(this);
        // FIXME this doesn't allow sharing of units where we need more than the max units
        this.textureUnit = componentRenderer.sharedState.claimTextureUnit();
        const context = componentRenderer.context;
        context.activeTexture(context.TEXTURE0 + this.textureUnit);
        this.uniformLocation = context.getUniformLocation(componentRenderer.program, this.name);
        this.texture = context.createTexture();
        context.bindTexture(context.TEXTURE_2D, this.texture);
        // FIXME this should be configurable
        context.pixelStorei(context.UNPACK_FLIP_Y_WEBGL, false);
        context.texParameteri(context.TEXTURE_2D, context.TEXTURE_MAG_FILTER, context.NEAREST);
        context.texParameteri(context.TEXTURE_2D, context.TEXTURE_MIN_FILTER, context.NEAREST);
        context.texParameteri(context.TEXTURE_2D, context.TEXTURE_WRAP_S, context.CLAMP_TO_EDGE);
        context.texParameteri(context.TEXTURE_2D, context.TEXTURE_WRAP_T, context.CLAMP_TO_EDGE);
    }
    updateData(canvas) {
        this.data = canvas;
        this.isDirty = true;
    }
    bind(componentRenderer) {
        if (this.data == null || this.textureUnit == null) {
            throw rc_js_util_1._Production.createError("expected data to be initialized");
        }
        if (this.isDirty) {
            const context = componentRenderer.context;
            context.activeTexture(context.TEXTURE0 + this.textureUnit);
            context.texImage2D(context.TEXTURE_2D, 0, context.RGBA, context.RGBA, context.UNSIGNED_BYTE, this.data);
            this.isDirty = false;
        }
    }
    onContextLost() {
        this.uniformLocation = null;
        this.texture = null;
        this.isDirty = true;
        this.textureUnit = null;
    }
}
exports.GlTexture2d = GlTexture2d;
//# sourceMappingURL=gl-texture2d.js.map